import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Status } from '../beans/status';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class StatusService {

	private readonly baseUrl = environment.serviceBaseUrl + '/api/statuses';

	constructor(private http: HttpService) { }

	getAll(): Observable<Status[]> {
		return this.http.get<Status[]>(this.baseUrl);
	}

	save(status: Status): Observable<Status> {
		return this.http.post<Status>(this.baseUrl, status);
	}
}
